import { Component, OnDestroy, HostListener } from '@angular/core';
import { Globals } from './globals';
import { UtilFunctions } from './util-functions';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from './authenticate/authentication.service';
import { Subscription } from 'rxjs';
import { MessagingService } from './messaging.service';



export let browserRefresh = false;

declare var $;
declare function info_noti(msg: any): any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'bootstrapToangular';
  subscription: Subscription;
  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {

  }
  // title = 'push-notification';
  message;
  buynowid
   
  
  constructor( private route: ActivatedRoute,private messagingService: MessagingService,private global: Globals, private router: Router) {

  }
  ngOnInit() {



   //notificate message recived 
    const userId = '2222';
    this.messagingService.requestPermission()
    this.messagingService.receiveMessage()
    this.message = this.messagingService.currentMessage
    if(this.message!=null){
      var obj = JSON.parse(this.message);
      info_noti(obj.notification.body);
    } 
  }
 
  ngOnDestroy() {
    // this.subscription.unsubscribe();
    info_noti(`I'm leaving the app!`);

  }


}
